/**
 * Метод загрузки модуля для добавления линейки.
 *
 * Отображает линейку на карте и позволяет определить расстояние между точками и площадь описываемой фигуры.
 * Этот модуль обеспечивает только расчет расстояния и отображение геодезической линии между опорными точками.
 * Отображение маркеров и их подписей определяется на стороне пользователя.
 *
 * @kind helper
 * @returns Промис получения модуля
 */
export const loadRuler = () => ymaps3.import('@yandex/ymaps3-ruler');
